const _axios = window.axios

export default {
  get_staff (id = 0) {
    return _axios.get('/erp/api.staff/info?id=' + id)
  },
  get_staff_statistics (param) {
    return _axios.get('/erp/api.staff/statistics', {
      params: param
    })
  },
  get_my_staffs () {
    return _axios.get('/erp/api.staff/get_my_staffs')
  }
}
